import { diffObject, } from './ObjectUtils.js';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function tail(value) {
    return value.slice(1);
}
/**
 * removes a value in-place.
 * Returns index of removed element or -1 if no element found
 */
export function removeItem(arr, value) {
    let write = 0;
    for (let read = 0; read < arr.length; read++) {
        if (arr[read] !== value) {
            // @ts-expect-error
            arr[write++] = arr[read];
        }
    }
    arr.length = write;
}
/**
 * computes the difference between two arrays.
 */
export function diffArray(source, // before
target, // after
props) {
    const isPair = props?.isPair ?? ((s, t) => s === t);
    const getChanged = props?.getChanged
        ?? ((s, t) => (typeof s === 'object' && typeof t === 'object' ? diffObject(s, t) : []));
    const removed = [];
    const changed = [];
    // unhanged in sense of getChanged.
    // But overall object may be different
    const unchanged = [];
    // track unmatched "after" items
    const remainingArr2 = [...target];
    for (const item1 of source) {
        const matchedItem2 = remainingArr2.find(item2 => isPair(item1, item2));
        if (matchedItem2) {
            const fields = getChanged(item1, matchedItem2);
            if (fields.length > 0) {
                changed.push({
                    before: item1,
                    after: matchedItem2,
                    fields,
                });
            }
            else {
                unchanged.push({ before: item1, after: matchedItem2 });
            }
            removeItem(remainingArr2, matchedItem2);
        }
        else {
            // existed before, missing after
            removed.push(item1);
        }
    }
    return {
        // new items in arr2
        added: remainingArr2,
        // missing from arr2
        removed,
        changed,
        unchanged,
    };
}
//# sourceMappingURL=ArrayUtils.js.map